<template>
  <v-container fluid class="grey lighten-4">
    <v-container class="py-10">
      <v-row>
        <v-col cols="12" sm="8">
          <div class="display-1 text-left" v-html="title"></div>
          <div class="mt-10 mb-5"
               :style="$vuetify.breakpoint.smAndUp ? `max-width: 85%;` : ''"
               v-html="description"></div>
        </v-col>
      </v-row>
      <v-row justify="center">
        <template v-for="(partner, pindex) in partners">
          <v-col cols="6" sm="3" lg="2" :key="`${pindex}pc`">
            <v-card color="#ffffff" elevation="0" min-height="280px" tile>
              <v-card-text>
                <v-img :src="`${publicPath}images/logo/${partner.logo}`"
                       aspect-ratio="1" :alt="`${partner.crm_customer_partner_data_code}`"
                       :title="`${partner.crm_customer_partner_data_code}`">
                </v-img>
                <div class="body-1 font-weight-black text-center mt-3">
                  {{ partner.crm_customer_partner_data_code }}
                </div>
              </v-card-text>
              <v-card-actions class="justify-center pb-4">
                <v-btn color="primary"
                       class="px-5"
                       rounded
                       @click="goToPartnerPage(partner)">
                  {{ $t('button.next') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </template>
      </v-row>
    </v-container>
  </v-container>
</template>

<script>
export default {
  name: 'PartnersContainer',
  components: {
    //
  },
  props: {
    description: {
      type: String,
      default: 'Leírás',
    },
    title: {
      type: String,
      default: 'Cím',
    },
  },
  mounted() {
    this.partners = this.$store.getters.getAppPartners;
  },
  data() {
    return {
      partners: [],
    };
  },
  methods: {
    goToPartnerPage(partner) {
      this.selectedPartner = partner;
      this.$router.push({ name: `partnerHome-${partner.campaign_type_code_lower}`, params: { partnerName: partner.url } });
    },
  },
};
</script>

<style scoped>

</style>
